import { useQuery } from '@vue/apollo-composable';
import { LIST_COURSE_OUTSTANDING_EXEMPTIONS } from '@/graphql/Queries/courseExemption';
import type {
  CourseOutstandingExemptionFilterInput,
  CourseOutstandingExemptionType,
} from '@/types/composition-functions';

export function useCourseExemptions() {
  const filter = ref<CourseOutstandingExemptionFilterInput>({});

  const { result, loading, error, refetch } = useQuery<{
    listCourseOutstandingExemptions: CourseOutstandingExemptionType[];
  }>(LIST_COURSE_OUTSTANDING_EXEMPTIONS, () => ({ filter: filter.value }), {
    fetchPolicy: 'cache-and-network',
  });

  const exemptions = computed<CourseOutstandingExemptionType[]>(
    () => result.value?.listCourseOutstandingExemptions ?? [],
  );

  function setFilter(newFilter: CourseOutstandingExemptionFilterInput) {
    filter.value = { ...newFilter };
  }

  function clearFilter() {
    filter.value = {};
  }

  return {
    exemptions,
    loading,
    error,
    refetch,
    filter,
    setFilter,
    clearFilter,
  };
}
